
function hamburgerMenu(body, nav, minWidth) {

    const toggleBtn = document.querySelector('.ne-nav__button')
    const burgerIcon = document.querySelector('.ne-nav__button--hamburger')
    const mqList = window.matchMedia(`(min-width: ${minWidth}px)`)

    let menuItemHasChildren = document.querySelectorAll('.menu-item-has-children')

    if( toggleBtn ) {

        toggleBtn.addEventListener('click', function() {

            body.classList.toggle('ne-nav--active')
            burgerIcon.classList.toggle('active')
        })
    }

    menuItemHasChildren.forEach( (item) => {

        item.addEventListener('mouseenter', function(e) {

            if( !body.classList.contains('ne-nav--active') ) {

                e.target.classList.add('current-menu-item')
            }
        })

        item.addEventListener('mouseleave', function(e) {

            if( !body.classList.contains('ne-nav--active') ) {

                e.target.classList.remove('current-menu-item')
            }
        })

        item.onclick = function(e) {

            if( body.classList.contains('ne-nav--active') ) {

                e.stopPropagation()
                e.target.parentElement.classList.toggle('current-menu-item')

            }
        }
    })

    mqList.addEventListener('change', (e) => {

        if( !e.matches || !body.classList.contains('ne-nav--active') ) return
        
        toggleBtn.childNodes[1].classList.remove('active')

        body.classList.remove('ne-nav--active')
    })

    // Accessibility
    Array.prototype.slice.call(nav).forEach(function (menuElements) {

        let allowMultiple = menuElements.hasAttribute('data-allow-multiple')
        let allowToggle = true

        menuElements.addEventListener('click', function (event) {

            let target = event.target;

            if( target.nodeName === 'A' ) {

                target = target.parentElement
            }

            if( target.classList.contains('menu-item-has-children') && target.children[0].href == '#' ) {

                event.preventDefault();
            }

            if (target.classList.contains('menu-item-has-children')) {

                let isExpanded = target.children[0].getAttribute('aria-expanded') === 'true';
                let active = menuElements.querySelector('[aria-expanded="true"]');

                if( !allowMultiple && active && active !== target.children[0] ) {

                    active.setAttribute('aria-expanded', 'false');
                    target.classList.remove('active');

                    if( !allowToggle ) {

                        active.removeAttribute('aria-disabled');
                    }
                }

                if( !isExpanded ) {

                    target.children[0].setAttribute('aria-expanded', 'true');
                    target.classList.add('active');

                    if( !allowToggle ) {

                        target.children[0].setAttribute('aria-disabled', 'true');
                    }

                } else if( allowToggle && isExpanded ) {

                    target.children[0].setAttribute('aria-expanded', 'false');
                    target.classList.remove('active');
                }
            }
        })
    })
}

document.addEventListener('DOMContentLoaded', function() {

    const body = document.body
    const minWidth = 1180;
    let nav = document.querySelectorAll('.ne-nav__menu')

    hamburgerMenu(body, nav, minWidth)
})